/* U Press Mock Up Lab — TEST prototype.
 *
 * Upload -> build your look -> create my scene -> place -> download.
 *
 * The only paid step is "Create my scene", which makes a blank garment in a
 * setting. Everything after it is done here in the browser, from the ORIGINAL
 * uploaded file every time, so placing and re-placing is free, instant, and
 * cannot degrade the artwork however many times it is repeated.
 */
(function () {
  'use strict';

  var cfg = window.UPM_CONFIG || {};
  if (cfg.layerTimeoutMs === undefined) cfg.layerTimeoutMs = 180000;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var MAX_UPLOAD = 150 * 1024 * 1024;

  var S = {
    art: null, artName: '', artRatio: 1, trim: null,
    /* size is no longer a control. Adult M is the base the placement shares
     * were calibrated against; the age bands take over for anyone younger. */
    choices: { garment: 'hoodie', colour: 'black', fit: 'regular', size: 'm',
               presentation: 'model', age: '', gender: 'masc', build: '', ethnicity: '',
               skin: '', hair: '', note: '',
               /* A print is sold by the inch, and the scene is now rendered with
                * the artwork already on it - so the size has to be chosen, not
                * inferred from a drag that no longer applies. */
               printSide: 'front', position: 'full-front', pose: 'square' },
    full: null, prev: null, placement: null, defaultPlacement: null,
    phase: 'empty',        /* empty | ready | adjusted | placing | finished */
    busy: false, finishedBlob: null,
    /* View state. Entirely separate from `placement`: zooming and panning
     * change what is on screen and never the design, the print size, the
     * clipping, the Place state or the file that comes out. */
    zoom: 1, tool: 'design', zoomChosen: false,
    /* One running job at a time. The token rises on every start, so a reply
     * from a superseded run cannot write over the current one. */
    jobToken: 0,
    /* One nonce per deliberate press. Corrective retries inside that press send
     * the same one, so the whole press takes a single slot however many
     * attempts it needs. A fresh press gets a fresh nonce. */
    nonce: null, jobKey: null,
    allowance: null,
    /* What happened last time, in enough detail to explain a failure without
     * keeping anything of the customer's. The uploaded design is never put in
     * here - only the scene the provider generated, and what we measured. */
    diagnostics: []
  };

  /* Where the time actually goes. Every phase is timed on every run and kept
   * with the attempt, so "it felt slow" can be answered with numbers instead of
   * guesses. Costs nothing and ships. */
  var T = null;
  function markStart() { T = { t0: now(), marks: [], last: now() }; }
  function mark(name) {
    if (!T) return;
    var n = now();
    T.marks.push({ phase: name, ms: Math.round(n - T.last) });
    T.last = n;
  }
  function timings() {
    if (!T) return null;
    var out = { totalMs: Math.round(now() - T.t0) };
    T.marks.forEach(function (m) { out[m.phase] = (out[m.phase] || 0) + m.ms; });
    return out;
  }
  function now() {
    return (window.performance && performance.now) ? performance.now() : Date.now();
  }

  /* What is left, and what to say when there is nothing left or nobody signed
   * in. The server decides all of this; the page only reports it. */
  function showAllowance() {
    var e = $('[data-upm-allow]');
    if (!e) return;
    var a = S.allowance;
    if (!a) { e.hidden = true; return; }
    if (a.signedIn === false) {
      e.innerHTML = 'Sign in to create your mockup. ' +
        '<a href="/account/login">Sign in</a>';
    } else if (a.remaining <= 0) {
      e.textContent = 'You have used all ' + a.allowance + ' of your scenes this month. ' +
        'They reset on ' + resetWord(a.resetsAt) + '.';
    } else {
      e.textContent = a.remaining + ' of ' + a.allowance + ' scenes left this month.';
    }
    e.hidden = false;
  }
  function resetWord(iso) {
    try {
      return new Date(iso).toLocaleDateString(undefined, { day: 'numeric', month: 'long' });
    } catch (e) { return 'the 1st'; }
  }
  function loadAllowance() {
    return api('/identity/mockup/quota').then(function (q) {
      if (q && q.ok) { S.allowance = q; showAllowance(); setPhase(S.phase); }
    }).catch(function () { /* the page still works; the server is the gate */ });
  }

  function announce(text) {
    var e = $('[data-upm-live]');
    if (e) e.textContent = text || '';
  }

  function note(text) {
    var e = $('[data-upm-busynote]');
    if (!e) return;
    e.textContent = text || '';
    e.hidden = !text;
  }

  var STAGES = ['generate', 'check', 'prepare'];
  var STAGE_WORDS = { generate: 'Generating your scene',
                      check: 'Checking your garment',
                      prepare: 'Preparing your preview' };

  /* Driven by what the job is actually doing. There is no timer here, no
   * percentage and no estimate, because we do not have one to give. */
  function setStage(name) {
    var at = STAGES.indexOf(name);
    /* `data-upm-step`, not `data-upm-stage`: the canvas already owns that one,
     * and $('[data-upm-stage]') returning a list item instead of the canvas
     * would take the whole editor down. */
    $$('[data-upm-step]').forEach(function (li) {
      var i = STAGES.indexOf(li.getAttribute('data-upm-step'));
      li.classList.toggle('is-now', i === at);
      li.classList.toggle('is-done', i >= 0 && i < at);
      if (i === at) li.setAttribute('aria-current', 'step');
      else li.removeAttribute('aria-current');
    });
    if (STAGE_WORDS[name]) announce(STAGE_WORDS[name]);
  }

  /* A cold segmentation model can take over a minute. With no sign of life the
   * panel reads as frozen and people press again, so the elapsed time is shown
   * - it is honest (it is a clock, not an estimate we do not have) and it is
   * the cheapest possible proof that something is still happening. */
  var busyClock = null;
  function showBusy(on) {
    var b = $('[data-upm-busy]');
    if (b) b.hidden = !on;
    if (on) { var f = $('[data-upm-fail]'); if (f) f.hidden = true; }
    var el = $('[data-upm-elapsed]');
    if (busyClock) { clearInterval(busyClock); busyClock = null; }
    if (!el) return;
    if (!on) { el.textContent = ''; return; }
    var t0 = Date.now();
    var tick = function () {
      var secs = Math.round((Date.now() - t0) / 1000);
      /* Two honest thresholds rather than one vague line. Past 45s it is slow;
       * past 75s it is almost certainly the segmentation model waking after a
       * quiet spell, measured at 73s and once at 137s. Naming that beats a
       * spinner that looks stuck. */
      var tail = secs > 75
        ? ' \u2014 the first scene after a quiet spell takes longer. Still working'
        : (secs > 45 ? ' \u2014 still working, this one is taking longer' : '');
      el.textContent = secs < 1 ? '' : (secs + 's' + tail);
    };
    tick();
    busyClock = setInterval(tick, 1000);
  }

  function showFail(message) {
    var f = $('[data-upm-fail]'), h = $('[data-upm-failhead]');
    if (h) h.textContent = message;
    if (f) f.hidden = false;
    showBusy(false);
    announce(message);
  }

  /* Zoom is a true percentage: 100% means one mockup pixel per screen pixel.
   * It is measured against the full-resolution scene, not against the canvas's
   * own width, because the canvas drops to a 760px working copy mid-drag and
   * the view must not jump when it does. */
  function natural() {
    if (S.full) return { w: S.full.surface.w, h: S.full.surface.h };
    /* During the early preview there is a picture on the canvas but no analysed
     * surface yet, so the canvas's own size is the honest answer. */
    var st = $('[data-upm-stage]');
    if (st && st.width > 1 && $('[data-upm-canvaswrap]').classList.contains('has-art')) {
      return { w: st.width, h: st.height };
    }
    return null;
  }
  function fitZoom() {
    var n = natural(), wrap = $('[data-upm-canvaswrap]');
    if (!n || !wrap || !wrap.clientWidth) return 1;
    return Math.min((wrap.clientWidth - 16) / n.w, (wrap.clientHeight - 16) / n.h);
  }

  function show(sel, on) { var e = $(sel); if (e) e.hidden = !on; }
  function say(msg, kind) {
    var e = $('[data-upm-status]');
    if (!e) return;
    e.textContent = msg || '';
    e.className = 'upm__msg' + (kind ? ' is-' + kind : '');
    e.hidden = !msg;
  }

  /* ------------------------------------------------------------- phases */

  /* Diagnostics stay available to us and out of the customer's way. */
  function applyDiagnostics() {
    var on = false;
    try { on = new URLSearchParams(location.search).get('upmdiag') === '1'; }
    catch (e) { on = false; }
    var ex = $('[data-upm-export]');
    if (ex) ex.hidden = !on;
    return on;
  }

  function setPhase(p) {
    applyDiagnostics();
    S.phase = p;
    /* Place is available whenever there is something to place. This is a
     * mockup, not a press plate: where the customer puts their design is their
     * decision, and the estimated print area is an estimate. */
    var placeable = (p === 'ready' || p === 'adjusted') && !S.busy;
    $('[data-upm-place]').disabled = !placeable;
    $('[data-upm-download]').disabled = (p !== 'finished');
    var rendered = S.mode === 'rendered';
    show('[data-upm-place]', !rendered);
    show('[data-upm-regen]', rendered);
    show('[data-upm-adjustopen]', rendered);
    if (!rendered) showAdjust(false);
    show('[data-upm-selbox]', !rendered);
    show('[data-upm-disclaim]', rendered);
    if (rendered) {
      var dl = $('[data-upm-download]'); if (dl) dl.disabled = false;
    }
    var rs = $('[data-upm-reset]'); if (rs) rs.disabled = (p === 'empty');
    $('[data-upm-export]').disabled = (p === 'empty');
    ['[data-upm-zoomrange]', '[data-upm-fit]', '[data-upm-zoomreset]'].forEach(function (sel) {
      var e = $(sel); if (e) e.disabled = (p === 'empty');
    });
    $$('[data-upm-tool]').forEach(function (b) { b.disabled = (p === 'empty'); });
    $('[data-upm-selbox]').classList.toggle('is-on',
      (p === 'ready' || p === 'adjusted') && S.tool === 'design');
    var failPanel = $('[data-upm-fail]');
    show('[data-upm-empty]', p === 'empty' && !S.busy && (!failPanel || failPanel.hidden));
    var rb = $('[data-upm-retry]');
    if (rb) rb.disabled = S.busy;
    $$('[data-upm-lib]').forEach(function (b) { b.disabled = S.busy || !S.art; });
    $('[data-upm-canvaswrap]').classList.toggle('has-art', p !== 'empty');

    /* The form stays on screen and readable at every step. What changes is
     * whether Create my scene can be pressed, and the line underneath says
     * why not - a disabled button with no reason is its own small puzzle. */
    var g = $('[data-upm-generate]'), why = $('[data-upm-why]');
    var a = S.allowance;
    var blocked = a && (a.signedIn === false || a.remaining <= 0);
    if (g) g.disabled = !S.art || S.busy || !!blocked;
    if (why) {
      why.textContent = S.busy ? 'Working on your scene…'
        : (!S.art ? 'Upload your design above and this turns on.'
        : (blocked ? '' : ''));
      why.hidden = !why.textContent;
    }
    if (p !== 'finished') S.finishedBlob = null;
  }

  /* Any edit makes a finished export stale. */
  function invalidate() {
    if (S.phase === 'finished' || S.phase === 'ready') S.phase = 'adjusted';
  }

  /* ------------------------------------------------------------- upload */

  function loadImage(src) {
    return new Promise(function (res, rej) {
      var i = new Image();
      /* The generated scene comes from a CDN that sends
       * access-control-allow-origin: *. Without asking for it the canvas is
       * tainted and both the analysis and the download fail. */
      if (/^https?:/i.test(src)) i.crossOrigin = 'anonymous';
      i.onload = function () { res(i); };
      i.onerror = function () { rej(new Error('Could not read that image.')); };
      i.src = src;
    });
  }

  /* The largest working copy we will build, in pixels on the long edge.
   *
   * A 100MB PNG is routinely 10000px square - 100 million pixels, 400MB once
   * decoded into a canvas. Chrome will allocate that and then stall; an iPhone
   * refuses outright and hands back a blank canvas with no error. 4096 is
   * comfortably inside every browser's limit, and it is still twice the width
   * of the scene the print is composited into, so nothing visible is lost. */
  var WORK_MAX = 4096;

  function busyUpload(on, text) {
    var e = $('[data-upm-upbusy]');
    if (!e) return;
    e.hidden = !on;
    if (on && text) $('[data-upm-upbusytext]').textContent = text;
    var f = $('[data-upm-file]');
    if (f) f.disabled = on;
  }

  /* Decode without blocking the page where the browser allows it.
   * createImageBitmap does the work off the main thread, which is the
   * difference between a page that pauses for four seconds on a phone and one
   * that does not. */
  function decode(file) {
    if (window.createImageBitmap) {
      return createImageBitmap(file).catch(function () { return decodeViaUrl(file); });
    }
    return decodeViaUrl(file);
  }
  function decodeViaUrl(file) {
    var url = URL.createObjectURL(file);
    return loadImage(url).then(function (img) {
      setTimeout(function () { URL.revokeObjectURL(url); }, 0);
      return img;
    }).catch(function (e) {
      URL.revokeObjectURL(url);
      throw e;
    });
  }

  /* A working copy at a size the rest of the tool can handle. One resample,
   * with the browser's best filter, straight from the decoded original - the
   * artwork is never re-drawn, re-coloured or traced, and the alpha channel
   * rides along untouched because the canvas is RGBA throughout. */
  function workingCopy(src) {
    var w = src.width, h = src.height;
    var k = Math.min(1, WORK_MAX / Math.max(w, h));
    if (k >= 1) return { img: src, scaled: false, w: w, h: h };
    var cw = Math.max(1, Math.round(w * k)), ch = Math.max(1, Math.round(h * k));
    var c = UPMRender.cv(cw, ch), g = c.getContext('2d');
    g.imageSmoothingEnabled = true;
    g.imageSmoothingQuality = 'high';
    g.clearRect(0, 0, cw, ch);
    g.drawImage(src, 0, 0, cw, ch);
    return { img: c, scaled: true, w: w, h: h };
  }

  async function onFile(file) {
    if (!file) return;
    if (!/^image\/(png|jpeg|webp)$/.test(file.type)) {
      say('That file type will not work here. Use a PNG, JPG or WEBP — a PNG with a ' +
          'transparent background gives the best result.', 'warn');
      return;
    }
    if (file.size > MAX_UPLOAD) {
      say('That file is ' + (file.size / 1048576).toFixed(0) + ' MB and the limit is ' +
          Math.round(MAX_UPLOAD / 1048576) + ' MB. Try exporting it again at a smaller size.',
          'warn');
      return;
    }
    say('');
    busyUpload(true, file.size > 8 * 1048576
      ? 'Opening ' + (file.size / 1048576).toFixed(0) + ' MB — this can take a moment…'
      : 'Opening your design…');
    /* Let the indicator paint before the decode takes the thread. */
    await new Promise(function (r) { setTimeout(r, 30); });

    var decoded = null;
    try {
      decoded = await decode(file);
      if (!decoded || !decoded.width || !decoded.height) throw new Error('no-size');

      var work = workingCopy(decoded);
      await new Promise(function (r) { setTimeout(r, 0); });

      S.art = work.img;
      S.artName = file.name;
      S.artRatio = work.img.height / work.img.width;
      /* A photograph and a graphic need different instructions: a photograph
       * has to be printed AS a photograph, and the people inside it must not be
       * mistaken for the model wearing the garment. A JPEG, or a PNG with no
       * transparency anywhere, is a photograph for this purpose. */
      S.artKind = /\.jpe?g$/i.test(file.name || '') ? 'photo' : 'graphic';
      /* A new upload starts a new scene, not an edit of the last one. */
      S.mode = 'composited';
      S.sceneImage = null;
      show('[data-upm-disclaim]', false);
      showPrintNote();

      /* Measure the design's real edges, so the selection box wraps the
       * artwork and not the transparent margin around it. */
      var cw = Math.min(640, work.img.width);
      var c = UPMRender.cv(cw, Math.max(1, Math.round(cw * S.artRatio)));
      var cg = c.getContext('2d');
      cg.clearRect(0, 0, c.width, c.height);
      cg.drawImage(work.img, 0, 0, c.width, c.height);
      S.trim = UPMCore.trimBounds(cg.getImageData(0, 0, c.width, c.height));

      var t = $('[data-upm-thumb]');
      if (t) {
        var tc = UPMRender.cv(160, Math.max(1, Math.round(160 * S.artRatio)));
        tc.getContext('2d').drawImage(work.img, 0, 0, tc.width, tc.height);
        t.src = tc.toDataURL('image/png');
      }
      $('[data-upm-artname]').textContent = file.name;
      $('[data-upm-artmeta]').textContent =
        work.w + ' × ' + work.h + ' px · ' + (file.size / 1048576).toFixed(1) + ' MB' +
        (work.scaled ? ' · working copy at ' + work.img.width + ' px' : '') +
        (S.trim && !S.trim.empty && S.trim.w < 0.98 ? ' · trimmed to the design' : '');
      show('[data-upm-artcard]', true);
      setPhase(S.phase);          /* Create my scene can be pressed now */
      if (S.full) resetPlacement();
    } catch (e) {
      var msg = (e && e.message === 'no-size')
        ? 'That image came back with no size. It may be corrupt — try exporting it again.'
        : 'That file could not be opened. If it is very large, try exporting it again at a ' +
          'smaller size; a PNG under 150 MB and 4000 px works best.';
      say(msg, 'warn');
    } finally {
      busyUpload(false);
      /* An ImageBitmap holds memory until it is closed. On a 100MB upload that
       * is hundreds of megabytes a phone would rather have back. */
      if (decoded && decoded !== S.art && decoded.close) {
        try { decoded.close(); } catch (e2) { /* nothing to do */ }
      }
    }
  }

  /* ------------------------------------------------------------ generate */

  function api(path, opts) {
    return fetch((cfg.proxy || '/apps/upress-ai') + path, opts).then(function (r) {
      return r.json().catch(function () { return { error: 'bad-response', status: r.status }; });
    });
  }

  /* Three different things, kept apart on purpose: the job is still running,
   * the job failed, or we ran out of patience. Only the middle one is the
   * provider's fault, and only the last one is a timeout - the old code called
   * a slow queue "taking longer than it should" and gave up at a fixed count
   * of polls regardless of how long that actually was. */
  function waitFor(ref, deadline) {
    var t0 = Date.now();
    return new Promise(function (res, rej) {
      (function poll() {
        if (Date.now() > deadline) {
          var e = new Error('timeout');
          e.kind = 'timeout';
          return rej(e);
        }
        api('/identity/mockup/status?ref=' + encodeURIComponent(ref)).then(function (s) {
          if (s.status === 'COMPLETED') return res();
          if (s.status === 'FAILED' || s.status === 'CANCELLED') {
            var f = new Error('job-' + String(s.status).toLowerCase());
            f.kind = 'failed';
            return rej(f);
          }
          /* Still working. The gap starts wide because nothing can possibly be
           * ready in the first few seconds, then tightens, so the finish is
           * noticed quickly instead of up to 2.5s late. Measured median
           * generation is 38s, so the tight window is where it matters. */
          var waited = Date.now() - t0;
          setTimeout(poll, waited < 20000 ? 2500 : (waited < 60000 ? 900 : 2000));
        }).catch(function () { setTimeout(poll, 3000); });
      }());
    });
  }

  /* The body of this request is S.choices and nothing else - seven dropdowns,
   * three buttons and a scene sentence. The uploaded design is never sent: it
   * is read into a canvas in this browser and stays there. The prompt itself is
   * built on the server from those choices, and comes back so a failure can be
   * explained afterwards. */
  async function makeBase(deadline) {
    setStage('generate');
    var g = await api('/identity/mockup/generate', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign({}, S.choices, { nonce: S.nonce }))
    });
    if (!g.ok) {
      /* Say what actually happened. A single catch-all sentence meant a client
       * running a stale script against a newer server produced "We could not
       * start that scene" and nothing to work from - which is exactly how one
       * real failure went unexplained. Every code the server can return now has
       * its own sentence, and anything unrecognised still reports its code. */
      var SAY = {
        'bad-nonce': 'This page is out of date — reload it and try again.',
        'bad-json': 'That request did not reach us properly. Reload the page and try again.',
        'unknown-shop': 'This store is not set up for scene generation yet.',
        'quota': 'Your allowance could not be read just now. Try again in a moment.',
        'daily-ceiling': 'Making new mockups is paused for today. Please try again tomorrow.',
        'upstream': 'The image service did not accept that request. Try again in a moment.'
      };
      var e = new Error(g.message || SAY[g.error] ||
        ('We could not start that scene (' + (g.error || 'unknown') + '). Try again in a moment.'));
      e.kind = g.error === 'sign-in-required' ? 'sign-in'
             : g.error === 'over-limit' ? 'over-limit'
             : g.error === 'daily-ceiling' ? 'ceiling'
             : g.error === 'rate-limited' ? 'rate-limited' : 'start';
      e.code = g.error || 'unknown';
      if (g.error === 'over-limit') {
        S.allowance = { signedIn: true, used: g.used, allowance: g.allowance,
                        remaining: 0, resetsAt: g.resetsAt };
        showAllowance();
      }
      if (g.error === 'sign-in-required') {
        S.allowance = { signedIn: false, allowance: 20 };
        showAllowance();
      }
      throw e;
    }
    if (g.jobKey) S.jobKey = g.jobKey;
    if (g.quota) { S.allowance = Object.assign({ signedIn: true }, g.quota); showAllowance(); }
    await waitFor(g.statusRef, deadline);
    var r = await api('/identity/mockup/result?ref=' + encodeURIComponent(g.resultRef));
    if (!r.ok || !r.images || !r.images.length) {
      var e2 = new Error('No image came back that time.');
      e2.kind = 'failed';
      throw e2;
    }
    mark('generate');
    setStage('check');
    var sceneUrl = r.images[0];

    /* The matte job and the scene download have nothing to say to each other,
     * so they run at the same time. In series this was a 3s matte followed by a
     * multi-megabyte download; together it is whichever of the two is slower. */
    var mattePromise = (async function () {
      var sg = await api('/identity/mockup/segment', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ imageUrl: sceneUrl })
      });
      if (!sg.ok) return null;
      try {
        await waitFor(sg.statusRef, deadline);
        var mr = await api('/identity/mockup/result?ref=' + encodeURIComponent(sg.resultRef));
        return (mr.ok && mr.images && mr.images.length) ? mr.images[0] : null;
      } catch (e3) { return null; }
    }());
    /* The garment layer is no longer requested here, and that is the result of
     * a benchmark rather than a retreat.
     *
     * It existed to repair a garment the model had made badly: infer the cloth,
     * find the cords, lift the hair. The scene brief now asks for a garment that
     * is already clean - blank, chest clear, hair behind the shoulders, no cords
     * over the print - and measured over eight scenes across seven colours, on
     * models and flat lays, every one came back that way and every one took
     * artwork cleanly with no layer at all.
     *
     * Dropping it removes the worst thing in the pipeline: a segmentation model
     * that costs 73 seconds when cold - and once took 137 - on a customer's
     * time, for a repair that is no longer needed. The route and the code remain
     * for a scene that proves difficult; what has gone is paying that toll on
     * every single generation.
     */
    var scenePromise = loadImage(sceneUrl);

    /* The moment the picture exists, show it. The customer sees their garment
     * while the matte and the analysis are still running, instead of a spinner
     * over a blank frame. Nothing is placed yet and nothing is clickable yet -
     * it is a photograph, honestly labelled by the stage list beside it. */
    scenePromise.then(function (img) {
      try {
        var st = $('[data-upm-stage]');
        if (!st || !S.busy) return;
        st.width = img.naturalWidth; st.height = img.naturalHeight;
        st.getContext('2d').drawImage(img, 0, 0);
        $('[data-upm-canvaswrap]').classList.add('has-art');
        if (!S.full) { S.zoom = fitZoom(); applyZoom(false); }
      } catch (e) { /* a preview is a nicety; never let it break the run */ }
    }).catch(function () {});

    var both = await Promise.all([
      scenePromise,
      mattePromise.then(function (u) { return u ? loadImage(u).catch(function () { return null; }) : null; })
    ]);
    mark('matte+transfer');
    return { sceneUrl: sceneUrl, prompt: g.prompt || '',
             sceneImg: both[0], maskImg: both[1], garmentImg: null };
  }



  /* Where a print goes, held as a SHARE of the panel rather than a number of
   * inches, so one placement looks right on a 2XL hoodie and on a toddler tee.
   * The shares come from the adult defaults measured against an Adult M tee -
   * a 20 inch panel - so left chest is 4in, center chest 8, full front 11.5,
   * oversized 14, upper back 11, full back 14, exactly as specified. */
  var PLACEMENTS = {
    'full-front':   { side: 'front', share: 0.575, label: 'Full front' },
    'left-chest':   { side: 'front', share: 0.20,  label: 'Left chest' },
    'pocket':       { side: 'front', share: 0.22,  label: 'Pocket area' },
    'full-back':    { side: 'back',  share: 0.70,  label: 'Full back' },
    'sleeve':       { side: 'front', share: 0.18,  label: 'Sleeve' },
    'thigh':        { side: 'front', share: 0.50,  label: 'Hip / thigh' },
    'hoodie-front': { side: 'front', share: 0.50,  label: 'Hoodie front' },
    'youth-front':  { side: 'front', share: 0.575, label: 'Youth front' },
    /* kept so an older link still resolves */
    'center-chest':    { side: 'front', share: 0.40, label: 'Center chest' },
    'oversized-front': { side: 'front', share: 0.70, label: 'Oversized front' },
    'upper-back':      { side: 'back',  share: 0.55, label: 'Upper back' }
  };

  /* Which placements exist on which garment, mirroring the server's table. A
   * hoodie has no clean full front - the pocket is in the way, which is what
   * "Hoodie front" is for - and a zip hoodie has no centred front at all
   * because the zip runs through it. Offering a placement a garment does not
   * have is worse than offering fewer. */
  var GARMENT_PLACES = {
    tshirt:        ['full-front', 'left-chest', 'full-back', 'sleeve'],
    tee:           ['full-front', 'left-chest', 'full-back', 'sleeve'],
    vneck:         ['full-front', 'left-chest', 'full-back', 'sleeve'],
    longsleeve:    ['full-front', 'left-chest', 'full-back', 'sleeve'],
    womensrelaxed: ['full-front', 'left-chest', 'full-back', 'sleeve'],
    crewneck:      ['full-front', 'left-chest', 'full-back', 'sleeve'],
    polo:          ['left-chest', 'full-back', 'sleeve'],
    tank:          ['full-front', 'left-chest', 'full-back'],
    racerback:     ['full-front', 'left-chest', 'full-back'],
    hoodie:        ['hoodie-front', 'left-chest', 'full-back', 'sleeve'],
    ziphoodie:     ['left-chest', 'full-back', 'sleeve'],
    youthtee:      ['youth-front', 'left-chest', 'full-back'],
    toddlertee:    ['youth-front', 'left-chest', 'full-back'],
    sweatpants:    ['thigh']
  };
  function garmentPlaces() {
    return GARMENT_PLACES[String(S.choices.garment || '')] || GARMENT_PLACES.tshirt;
  }

  /* A one-line reason, so a customer who came looking for "Full front" on a zip
   * hoodie is told why it is not there rather than assuming we forgot. */
  var PLACE_WHY = {
    ziphoodie: 'A zip runs down the front, so a centred front print is not ' +
               'possible on this one.',
    polo: 'A polo has a buttoned placket down the middle, so there is no ' +
          'centred full-front print.',
    hoodie: 'On a hoodie the front print sits above the kangaroo pocket.',
    sweatpants: 'Sweatpants take a hip and thigh print.',
    tank: 'A tank has no sleeve to print on.',
    racerback: 'A racerback has no sleeve to print on.',
    youthtee: 'Youth sizes use a smaller front print.',
    toddlertee: 'Toddler sizes use a smaller front print.'
  };

  /* A child is not a small adult. Measuring a toddler print against an 18 inch
   * adult Small is what made an 8 inch print run shoulder to shoulder on a
   * toddler tee. Midpoints of the bands: baby 9-11, toddler 11-13, child
   * 13-16, teen 16-18. Mirrors the server's table. */
  var YOUTH_PANEL = { baby: 10, toddler: 12, child: 14.5, teen: 17 };

  /* What the summary calls the wearer's size. */
  var AGE_LABEL = { baby: 'Baby', toddler: 'Toddler', child: 'Child', teen: 'Teen' };

  /* The scene box asks for different things depending on what is being
   * photographed. A flat lay has no scene to be in; it has a surface. */
  var SCENE_LABEL = {
    model: 'Describe your scene',
    flat: 'Describe the flat lay background',
    hanging: 'Describe the hanging garment scene'
  };
  var SCENE_HINT = {
    model: 'A dirt-track race shop, a Friday-night football tailgate, or a cozy ' +
           'Christmas setup — tell us the setting and style you have in mind.',
    flat: 'A pale wood table, a clean white surface, or a few seasonal props set ' +
          'off to the side — tell us what it is lying on.',
    hanging: 'A plain studio wall, a boutique rail, or a timber barn door — ' +
             'tell us what is behind it.'
  };

  /* Only the fields that mean something for what is being photographed. A flat
   * lay has no model, so asking for their hair is noise. */
  function applyDisplayMode() {
    var mode = S.choices.presentation === 'flat' ? 'flat'
             : S.choices.presentation === 'hanging' ? 'hanging' : 'model';
    show('[data-upm-person]', mode === 'model');
    var lab = $('[data-upm-scenelabel]');
    if (lab) lab.textContent = SCENE_LABEL[mode];
    var box = $('[data-upm-note]');
    if (box) box.setAttribute('placeholder', SCENE_HINT[mode]);
  }

  /* Only the placements the chosen garment really has, and the print side is
   * no longer a separate question: "Full back" IS the back, so the chosen
   * button decides what the camera sees. Asking for the side as well let a
   * customer pick Front and Full back at the same time. */
  function applyPlacements() {
    var list = garmentPlaces();
    var shown = {};
    list.forEach(function (k) { shown[k] = 1; });
    $$('[data-upm-pick][data-upm-group="position"]').forEach(function (b) {
      b.hidden = !shown[b.getAttribute('data-upm-value')];
    });
    if (!shown[S.choices.position]) S.choices.position = list[0];
    $$('[data-upm-pick][data-upm-group="position"]').forEach(function (b) {
      b.setAttribute('aria-pressed',
        b.getAttribute('data-upm-value') === S.choices.position ? 'true' : 'false');
    });
    /* printSide is still sent, and still read by older links, but it is now
     * DERIVED - there is no control that can disagree with the placement. */
    var pl = PLACEMENTS[S.choices.position];
    S.choices.printSide = (pl && pl.side === 'back') ? 'back' : 'front';
    var why = $('[data-upm-placenote]');
    if (why) {
      var txt = PLACE_WHY[String(S.choices.garment || '')] || '';
      why.textContent = txt;
      why.hidden = !txt;
    }
  }
  /* kept under its old name so existing callers still work */
  function applyPrintSide() { applyPlacements(); }

  /* The width now FOLLOWS the garment, its size, the wearer's age and the
   * placement. Picking "Left chest" has already said how big the print is;
   * asking for inches as well was asking the same question twice and accepting
   * two answers that could disagree. The advanced control still overrides it,
   * and that override only governs the preview - the order takes its inches
   * from the production flow. */
  function autoWidth() {
    var pl = PLACEMENTS[S.choices.position] || PLACEMENTS['full-front'];
    return Math.round(panelInches() * pl.share * 2) / 2;
  }
  /* There is no manual width any more. A customer who wants a particular size
   * writes it in the scene box, and the brief is told that a size asked for in
   * words beats the one we worked out. */
  function effectiveWidth() { return autoWidth(); }
  function syncWidthBox() { /* the control it synced is gone */ }
  function setTypicalWidth() { showSummary(); }

  /* How the wearer's size reads in the summary: the age band when it is a
   * child, the garment size when it is an adult. */
  /* With the Size dropdown gone there is no letter to show, so the summary
   * says who it is sized for rather than quoting a size nobody picked. */
  var GARMENT_WORD = { youthtee: 'Youth', toddlertee: 'Toddler',
                       sweatpants: 'Adult' };
  function sizeWord() {
    return AGE_LABEL[String(S.choices.age || '')] ||
           GARMENT_WORD[String(S.choices.garment || '')] || 'Adult';
  }

  /* One compact line, beside the picture rather than in the form. */
  function showSummary() {
    var el = $('[data-upm-summary]');
    if (!el) return;
    if (!S.art) { el.hidden = true; return; }
    var pl = PLACEMENTS[S.choices.position] || PLACEMENTS['full-front'];
    el.textContent = 'Print: ' + pl.label + ' • Auto size for ' + sizeWord() +
      ' • AI mockup only';
    el.hidden = false;
  }

  /* A dropdown is a decision; a sentence in the notes box is a wish. When they
   * disagree the server is told the dropdown wins - but the customer should
   * know, because the thing they typed is the thing they will look for. */
  var AGE_WORDS = {
    baby: /\b(toddler|child|kid|teen|teenager|adult|man|woman|grandma|grandpa)\b/i,
    toddler: /\b(baby|infant|teen|teenager|adult|man|woman|grandma|grandpa)\b/i,
    child: /\b(baby|infant|toddler|adult|man|woman|grandma|grandpa)\b/i,
    teen: /\b(baby|infant|toddler)\b/i,
    twenties: /\b(baby|infant|toddler|child|kid|little girl|little boy)\b/i,
    thirties: /\b(baby|infant|toddler|child|kid|teen|teenager|little girl|little boy|young girl|young boy)\b/i,
    forties: /\b(baby|infant|toddler|child|kid|teen|teenager|young girl|young boy)\b/i,
    fifties: /\b(baby|infant|toddler|child|kid|teen|teenager)\b/i,
    sixtyplus: /\b(baby|infant|toddler|child|kid|teen|teenager)\b/i
  };
  function checkAgeConflict() {
    var el = $('[data-upm-conflict]');
    if (!el) return;
    var age = String(S.choices.age || '');
    var note = String(S.choices.note || '');
    var re = AGE_WORDS[age];
    var hit = (age && note && S.choices.presentation === 'model' && re) ? note.match(re) : null;
    if (!hit) { el.hidden = true; return; }
    el.textContent = 'Your scene says "' + hit[0] + '", but Age is set to ' +
      ageWord() + '. We will follow the Age you picked — change one of them if ' +
      'that is not what you want.';
    el.hidden = false;
  }
  function ageWord() {
    var sel = $('[data-upm-choice="age"]');
    if (!sel) return String(S.choices.age || '');
    var o = sel.options[sel.selectedIndex];
    return o ? o.textContent : String(S.choices.age || '');
  }

  /* ------------------------------------------------- whole-scene rendering
   *
   * The customer's artwork goes to the model as a reference and comes back
   * already printed on the garment: the print follows the weave, the garment's
   * curve and the scene's own light, which compositing could only imitate.
   *
   * Their approved file never leaves this tab and is never touched. What is
   * sent is a reduced COPY, made here, purely as a reference for the model -
   * S.art, the thing any print would be made from, is not modified. */

  /* Front panel widths, mirroring the table the server uses, so the page can
   * show what proportion of the chest the chosen inches work out at before
   * anything is spent. A documented reference, not a measurement. */
  var PANEL_IN = {
    tshirt: { s: 18, m: 20, l: 22, xl: 24, xxl: 26 },
    tee: { s: 18, m: 20, l: 22, xl: 24, xxl: 26 },
    vneck: { s: 18, m: 20, l: 22, xl: 24, xxl: 26 },
    longsleeve: { s: 18, m: 20, l: 22, xl: 24, xxl: 26 },
    womensrelaxed: { s: 18, m: 20, l: 22, xl: 24, xxl: 26 },
    polo: { s: 19, m: 21, l: 23, xl: 25, xxl: 27 },
    crewneck: { s: 20, m: 22, l: 24, xl: 26, xxl: 28 },
    hoodie: { s: 20, m: 22, l: 24, xl: 26, xxl: 28 },
    ziphoodie: { s: 20, m: 22, l: 24, xl: 26, xxl: 28 },
    tank: { s: 17, m: 19, l: 21, xl: 23, xxl: 25 },
    racerback: { s: 15, m: 17, l: 19, xl: 21, xxl: 23 },
    youthtee: { s: 14, m: 15, l: 16, xl: 17, xxl: 18 },
    toddlertee: { s: 11, m: 12, l: 13, xl: 13, xxl: 13 },
    /* not a chest at all: the usable area is the thigh */
    sweatpants: { s: 8, m: 9, l: 10, xl: 11, xxl: 12 }
  };
  function panelInches() {
    var youth = YOUTH_PANEL[String(S.choices.age || '')];
    if (youth) return youth;
    var t = PANEL_IN[S.choices.garment] || PANEL_IN.tshirt;
    return t[S.choices.size] || t.l;
  }
  function printInches() {
    var panel = panelInches();
    var w = Math.max(2, Math.min(panel, effectiveWidth()));
    var h = w * (S.artRatio || 1);
    return { w: w, h: h, panel: panel, pct: Math.round(100 * w / panel) };
  }
  /* The old note lived in the form and made it feel cramped. The same facts are
   * now one line beside the preview; this keeps the name so existing callers
   * still work. */
  function showPrintNote() { showSummary(); }

  /* A reduced copy for the model to look at. Big enough to reproduce lettering,
   * small enough to send. */
  /* The garment colour the customer picked, read from the swatch itself so
   * there is one source of truth for it rather than a second table here. */
  function garmentHex() {
    var sw = $('[data-upm-pick][data-upm-group="colour"][aria-pressed="true"]');
    if (!sw) return '#FFFFFF';
    var bg = getComputedStyle(sw).backgroundColor;
    return bg && bg !== 'rgba(0, 0, 0, 0)' ? bg : '#FFFFFF';
  }

  /* A reduced copy for the model to look at. Big enough to reproduce lettering,
   * small enough to send.
   *
   * It is drawn onto the GARMENT COLOUR first, and that is not cosmetic. A
   * transparent PNG carries whatever RGB the exporter left under the clear
   * pixels, and for most artwork that is black. Sent with its alpha intact,
   * anything downstream that drops the alpha gets black lettering on a black
   * field - and the design comes back with its words missing and only the
   * coloured shapes surviving. That is a real defect a customer hit, not a
   * theory: flattening their file onto black reproduced their broken mockup
   * almost exactly.
   *
   * The garment colour is the right ground because it is also the truthful
   * one: the reference then shows the print as it will actually sit on that
   * shirt, so the model is not guessing at contrast either. */
  function artworkReference() {
    var src = S.art;
    if (!src) return null;
    var sw = src.naturalWidth || src.width, sh = src.naturalHeight || src.height;
    var sc = Math.min(1, 1536 / Math.max(sw, sh));
    var c = UPMRender.cv(Math.round(sw * sc), Math.round(sh * sc));
    var g = c.getContext('2d');
    g.fillStyle = garmentHex();
    g.fillRect(0, 0, c.width, c.height);
    g.imageSmoothingQuality = 'high';
    g.drawImage(src, 0, 0, c.width, c.height);
    return c.toDataURL('image/png');
  }

  /* A bounded check for the obvious failures, not a grader.
   *
   * It asks one question the eye would ask first: is the artwork actually
   * there? The artwork's own strong colours are counted in the middle of the
   * garment, where the print should be, ignoring anything close to the garment
   * colour. A render that lost the design, or hid it behind a pose, comes back
   * near zero. Distorted lettering and small colour drift are NOT detected -
   * that is what the notice under the picture is for, and what Regenerate is
   * for. One retry, then the customer decides. */
  function sceneLooksPrinted(sceneImg) {
    try {
      var N = 220;
      var a = UPMRender.cv(N, N), ag = a.getContext('2d');
      ag.drawImage(S.art, 0, 0, N, N);
      var ad = ag.getImageData(0, 0, N, N).data;
      var sw = sceneImg.naturalWidth || sceneImg.width;
      var sh = sceneImg.naturalHeight || sceneImg.height;
      /* the middle of the garment, where a chest print lives */
      var bx = Math.round(sw * 0.28), by = Math.round(sh * 0.28);
      var bw = Math.round(sw * 0.44), bh = Math.round(sh * 0.34);
      var b = UPMRender.cv(N, N), bg = b.getContext('2d');
      bg.drawImage(sceneImg, bx, by, bw, bh, 0, 0, N, N);
      var bd = bg.getImageData(0, 0, N, N).data;
      var key = {}, i, k, n = N * N;
      var q = function (d, j) {
        return ((d[j] >> 5) << 10) | ((d[j + 1] >> 5) << 5) | (d[j + 2] >> 5);
      };
      for (i = 0, k = 0; i < n; i++, k += 4) { if (ad[k + 3] > 128) key[q(ad, k)] = 1; }
      /* the garment's own colour, read from a strip below the print area */
      var c2 = UPMRender.cv(40, 20), g2 = c2.getContext('2d');
      g2.drawImage(sceneImg, Math.round(sw * 0.35), Math.round(sh * 0.70),
                   Math.round(sw * 0.30), Math.round(sh * 0.08), 0, 0, 40, 20);
      var gd = g2.getImageData(0, 0, 40, 20).data, garment = {};
      for (i = 0, k = 0; i < 800; i++, k += 4) garment[q(gd, k)] = 1;
      var hit = 0, counted = 0;
      for (i = 0, k = 0; i < n; i++, k += 4) {
        var code = q(bd, k);
        if (garment[code]) continue;
        counted++;
        if (key[code]) hit++;
      }
      var share = counted > 40 ? hit / counted : 0;
      return { ok: share >= 0.12, share: +share.toFixed(3) };
    } catch (e) {
      /* a check that cannot run must never reject a customer's scene */
      return { ok: true, share: null, skipped: true };
    }
  }


  /* ---------------------------------------------------------- adjusting
   *
   * A render can be right in every way but one. Throwing it away and rolling
   * again loses the model, the light and the background the customer already
   * liked. An adjustment goes back with the mockup AS IT STANDS plus their
   * artwork, and asks for one named change.
   *
   * It is a second generation and it costs a scene. The panel says so; nobody
   * finds out from their allowance.
   *
   * The approved file still never leaves this tab. What goes up is a reduced
   * copy of the picture already on screen and a reduced copy of the artwork -
   * neither is kept, and S.art is not touched. */

  /* The scene as a reference. JPEG, because a 2048x3072 PNG is about nine
   * megabytes and the upstream cap is ten - and this is a thing to look at,
   * not a thing to print. */
  function sceneReference() {
    var src = S.sceneImage;
    if (!src) return null;
    var sw = src.naturalWidth || src.width, sh = src.naturalHeight || src.height;
    var sc = Math.min(1, 1536 / Math.max(sw, sh));
    var c = UPMRender.cv(Math.round(sw * sc), Math.round(sh * sc));
    var g = c.getContext('2d');
    g.imageSmoothingQuality = 'high';
    /* a ground under it, so a transparent edge cannot come out black */
    g.fillStyle = '#FFFFFF'; g.fillRect(0, 0, c.width, c.height);
    g.drawImage(src, 0, 0, c.width, c.height);
    return c.toDataURL('image/jpeg', 0.94);
  }

  var ADJUST_SAY = {
    smaller: 'Making the print smaller…', larger: 'Making the print larger…',
    higher: 'Moving the print higher…', lower: 'Moving the print lower…',
    center: 'Centering the print…', background: 'Cleaning up the background…',
    age: 'Adjusting the model…', wider: 'Showing more of the garment…'
  };

  function showAdjust(on) {
    var el = $('[data-upm-adjust]');
    if (!el) return;
    el.hidden = !on;
    if (on) {
      /* "Match age better" means nothing without an age, or without a person */
      var ageBtn = $('[data-upm-adj-age]');
      if (ageBtn) {
        var usable = S.choices.presentation === 'model' && !!S.choices.age;
        ageBtn.disabled = !usable;
        ageBtn.title = usable ? '' : 'Pick an Age in step 02 first.';
      }
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  async function adjustScene(kind) {
    if (S.busy) return;
    if (!S.sceneImage) { say('Make a mockup first.', 'warn'); return; }
    var scene = sceneReference(), art = artworkReference();
    if (!scene || !art) { say('That mockup could not be read back. Try Regenerate.', 'warn'); return; }

    var myToken = ++S.jobToken;
    S.busy = true; setPhase(S.phase); say(''); note('');
    showAdjust(false); showFailPanel(false); showBusy(true); markStart();
    $('[data-upm-busyhead]').textContent = ADJUST_SAY[kind] || 'Adjusting your mockup…';
    setStage('generate');
    /* a fresh nonce: this is a different job from the scene it came from */
    S.nonce = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);

    try {
      var g = await api('/identity/mockup/adjust', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ adjust: kind, scene: scene, art: art,
                               age: S.choices.age, nonce: S.nonce })
      });
      if (myToken !== S.jobToken) return;
      if (!g.ok) {
        var e = new Error(g.message || sceneErrorText(g.error));
        e.kind = g.error === 'sign-in-required' ? 'sign-in'
               : g.error === 'over-limit' ? 'over-limit'
               : g.error === 'daily-ceiling' ? 'ceiling' : 'start';
        throw e;
      }
      if (g.jobKey) S.jobKey = g.jobKey;
      if (g.quota) { S.allowance = g.quota; showAllowance(); }

      var deadline = Date.now() + (cfg.jobTimeoutMs || 150000);
      await waitFor(g.statusRef, deadline);
      if (myToken !== S.jobToken) return;
      setStage('check');
      var r = await api('/identity/mockup/result?ref=' + encodeURIComponent(g.resultRef));
      if (!r.ok || !r.images || !r.images.length) throw new Error('No mockup came back.');
      var img = await loadImage(r.images[0]);
      if (myToken !== S.jobToken) return;

      /* An adjustment is NOT retried automatically. A retry would spend a
       * second scene on a judgement the customer is better placed to make -
       * they can see the picture and we cannot. */
      var look = sceneLooksPrinted(img);
      S.diagnostics.push({ at: new Date().toISOString(), source: 'adjust',
        adjust: kind, choices: Object.assign({}, S.choices), check: look,
        trusted: false });
      if (S.diagnostics.length > 12) S.diagnostics.shift();

      setStage('prepare');
      adoptScene(img, printInches(), look);
      say('Adjusted. Not quite right? Adjust again, or regenerate for a new scene.', 'ok');
    } catch (err) {
      if (myToken !== S.jobToken) return;
      if (S.jobKey && err.kind !== 'sign-in' && err.kind !== 'over-limit') {
        try {
          var back = await api('/identity/mockup/abandon', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ jobKey: S.jobKey })
          });
          if (back && back.quota) { S.allowance = back.quota; showAllowance(); }
          S.jobKey = null;
        } catch (e2) { /* the server sweep is the backstop */ }
      }
      showFail(err.message || 'We could not adjust that one just then. ' +
               'Your mockup is still here and none of your allowance was used.');
    } finally {
      if (myToken === S.jobToken) { S.busy = false; setPhase(S.phase); }
    }
  }

  async function renderScene(isRetry) {
    if (S.busy) return;
    if (!S.art) { say('Add your artwork first — step 01.', 'warn'); return; }
    var myToken = ++S.jobToken;
    S.busy = true; setPhase(S.phase); say(''); note('');
    showFailPanel(false);
    showBusy(true);
    markStart();
    $('[data-upm-busyhead]').textContent = isRetry
      ? 'That one did not come back right, trying once more…'
      : 'Creating your mockup…';
    setStage('generate');
    if (!S.nonce || !isRetry) S.nonce = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);

    try {
      var p = printInches();
      /* printWidthIn is sent only when the customer took the advanced control.
       * Left out, the server works the width out from the same garment, size,
       * age and placement the page used - one rule, in one place. */
      var payload = Object.assign({}, S.choices, {
        art: artworkReference(), artRatio: S.artRatio || 1,
        artKind: S.artKind || 'graphic', nonce: S.nonce
      });
      /* The server works the width out from the same garment, age and
       * placement the page used - one rule, in one place - and a size the
       * customer asked for in words overrides it there. */
      delete payload.printWidthIn;
      var g = await api('/identity/mockup/scene', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (myToken !== S.jobToken) return;
      if (!g.ok) {
        var e = new Error(g.message || sceneErrorText(g.error));
        e.kind = g.error === 'sign-in-required' ? 'sign-in'
               : g.error === 'over-limit' ? 'over-limit'
               : g.error === 'daily-ceiling' ? 'ceiling' : 'start';
        throw e;
      }
      if (g.jobKey) S.jobKey = g.jobKey;
      if (g.quota) { S.allowance = g.quota; showAllowance(); }

      var deadline = Date.now() + (cfg.jobTimeoutMs || 150000);
      await waitFor(g.statusRef, deadline);
      if (myToken !== S.jobToken) return;
      setStage('check');
      var r = await api('/identity/mockup/result?ref=' + encodeURIComponent(g.resultRef));
      if (!r.ok || !r.images || !r.images.length) throw new Error('No scene came back.');
      var img = await loadImage(r.images[0]);
      if (myToken !== S.jobToken) return;

      var look = sceneLooksPrinted(img);
      S.diagnostics.push({ at: new Date().toISOString(), source: 'scene',
        choices: Object.assign({}, S.choices), print: p, attempt: isRetry ? 2 : 1,
        check: look, trusted: false });
      if (S.diagnostics.length > 12) S.diagnostics.shift();

      if (!look.ok && !isRetry) { S.busy = false; return renderScene(true); }

      setStage('prepare');
      adoptScene(img, p, look);
    } catch (err) {
      if (myToken !== S.jobToken) return;
      if (S.jobKey && err.kind !== 'sign-in' && err.kind !== 'over-limit') {
        try {
          var back = await api('/identity/mockup/abandon', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ jobKey: S.jobKey })
          });
          if (back && back.quota) { S.allowance = back.quota; showAllowance(); }
          S.jobKey = null;
        } catch (e2) { /* the server sweep is the backstop */ }
      }
      showFail(err.message || 'We could not make that scene just then. ' +
               'None of your allowance was used.');
    } finally {
      if (myToken === S.jobToken) { S.busy = false; setPhase(S.phase); }
    }
  }

  function sceneErrorText(code) {
    var SAY = {
      'bad-artwork': 'That artwork could not be sent. Try uploading it again.',
      'bad-json': 'That request did not reach us properly. Reload and try again.',
      'unknown-shop': 'This store is not set up for scene generation yet.',
      'quota': 'Your allowance could not be read just now. Try again in a moment.',
      'daily-ceiling': 'Making new mockups is paused for today. Please try again tomorrow.',
      'upstream': 'The image service did not accept that request. Try again in a moment.',
      'rate-limited': 'That is a lot of mockups in a few minutes. Try again shortly.'
    };
    return SAY[code] || ('We could not start that scene (' + (code || 'unknown') + ').');
  }

  /* The finished scene. There is nothing to drag - the print is in the picture -
   * so the editor's placement tools stand down and the notice comes up. */
  function adoptScene(img, p, look) {
    var st = $('[data-upm-stage]');
    st.width = img.naturalWidth || img.width;
    st.height = img.naturalHeight || img.height;
    st.getContext('2d').drawImage(img, 0, 0);
    $('[data-upm-canvaswrap]').classList.add('has-art');
    S.full = null; S.prev = null; S.placement = null;
    S.sceneImage = img;
    S.finishedBlob = null;
    S.mode = 'rendered';
    S.zoom = fitZoom(); applyZoom(false);
    showBusy(false);
    show('[data-upm-disclaim]', true);
    showSummary();
    /* The slot is spent: the customer has a scene. */
    if (S.jobKey) {
      var settled = S.jobKey; S.jobKey = null;
      api('/identity/mockup/commit', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ jobKey: settled })
      }).then(function (c) {
        if (c && c.ok && c.quota) { S.allowance = c.quota; showAllowance(); }
      }).catch(function () {});
    }
    /* The check's number is ours, not the customer's. They get a plain sentence
     * and a button, never a score. */
    if (look && !look.ok) {
      say('This one may not show your design clearly. Press Regenerate to try ' +
          'another, or keep it.', 'warn');
    }
    setPhase('finished');
    announce('Your mockup is ready.');
    $('[data-upm-canvaswrap]').scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function showFailPanel(on) {
    var f = $('[data-upm-fail]');
    if (f) f.hidden = !on;
  }

  async function generate() {
    /* One job at a time. The flag is set before the first await, so a second
     * click - or a third, or a double-click - cannot get past this line while
     * the first is still running, and cannot start a second paid request. */
    if (S.busy) return;
    if (!S.art) { say('Add your artwork first — step 01.', 'warn'); return; }

    var myToken = ++S.jobToken;
    /* One nonce for this press. Every corrective retry below reuses it, so the
     * server counts the press once however many attempts it takes. */
    S.nonce = (Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
    S.jobKey = null;
    S.busy = true;
    $('[data-upm-generate]').disabled = true;
    setPhase(S.phase);
    say('');
    showBusy(true);
    note('');
    setStage('generate');

    var budget = Math.max(30000, Number(cfg.totalBudgetMs || 240000));
    var jobMax = Math.max(20000, Number(cfg.jobTimeoutMs || 150000));
    var started = Date.now();
    markStart();
    var hardStop = started + budget;
    var maxExtra = Math.max(0, Number(cfg.maxRetries === undefined ? 1 : cfg.maxRetries));
    var attempts = 0, adopted = false, last = null;

    try {
      while (attempts <= maxExtra && !adopted) {
        attempts++;
        if (attempts > 1) {
          /* A corrective retry. Say so plainly, and say that nothing of theirs
           * has been lost, because the obvious fear is that it has. */
          setStage('generate');
          note('That one came back unusable, so we are trying once more. ' +
               'Your design and your choices are saved.');
          announce('Trying once more. Your design and your choices are saved.');
        }
        var deadline = Math.min(hardStop, Date.now() + jobMax);
        var got = await makeBase(deadline);
        if (myToken !== S.jobToken) return;      /* superseded; leave state alone */

        var why = await adoptBase(got);
        if (myToken !== S.jobToken) return;

        S.diagnostics.push({
          at: new Date().toISOString(), attempt: attempts,
          choices: Object.assign({}, S.choices),
          prompt: got.prompt, scene: got.sceneUrl, matte: !!got.maskUrl,
          verdict: why === null ? 'used' : why.reason, trusted: true, measured: why === null ? null : why.measured,
          timings: timings()
        });
        if (S.diagnostics.length > 12) S.diagnostics.shift();

        if (why === null) { adopted = true; break; }
        last = why;
        /* A retry exists for one reason: the model printed something on the
         * garment, and a fresh scene would not. It regenerates the WHOLE scene,
         * which is a second paid image.
         *
         * A missing garment layer is not that. The scene was very likely fine -
         * what failed was the segmentation call, usually because the model was
         * cold - and buying another scene cannot fix it. So that one stops
         * here, keeps the customer's slot, and offers a template. */
        if (why.reason === 'no-layer-evidence') break;
        if (Date.now() > hardStop) break;
      }

      if (!adopted) {
        var e = new Error((last && last.message) ||
          'We could not make a usable scene just then.');
        e.kind = 'rejected';
        e.attempts = attempts;
        throw e;
      }
      showBusy(false);
      note('');
      /* Settle the slot now, and only now. Up to this point the customer has
       * nothing, so anything that goes wrong - including walking away - gives
       * it back. From here they have a scene, so it is genuinely spent. */
      if (S.jobKey) {
        var settled = S.jobKey;
        S.jobKey = null;
        api('/identity/mockup/commit', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ jobKey: settled })
        }).then(function (c) {
          if (c && c.ok && c.quota) { S.allowance = c.quota; showAllowance(); }
        }).catch(function () { /* the server sweep is the backstop */ });
      }
      announce('Your mockup is ready. Drag the design to move it.');
      $('[data-upm-canvaswrap]').scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (err) {
      if (myToken !== S.jobToken) return;
      var secs = Math.round((Date.now() - started) / 1000);
      var msg;
      if (err.kind === 'timeout') {
        msg = 'That is still being made after ' + secs + ' seconds, which is longer ' +
              'than we are prepared to keep you waiting. Nothing has been lost.';
      } else if (err.kind === 'rate-limited') {
        msg = err.message;
      } else if (err.kind === 'rejected') {
        msg = err.message + ' We stopped after ' + err.attempts +
              (err.attempts === 1 ? ' try' : ' tries') + ' rather than keep spending on it.';
      } else if (err.kind === 'sign-in') {
        msg = 'Sign in to your account to create your mockup.';
      } else if (err.kind === 'over-limit' || err.kind === 'ceiling') {
        msg = err.message;
      } else if (err.kind === 'failed') {
        msg = 'The image service could not finish that one. Nothing has been lost — ' +
              'press Try again.';
      } else {
        msg = err.message || 'Something went wrong making that scene.';
      }
      /* Enough to explain the next failure without keeping anything of theirs:
       * what was asked for, what came back, and what we measured. */
      if (window.console && console.warn) {
        console.warn('[Mock Up Lab] generation failed after ' + secs + 's:', msg,
                     S.diagnostics[S.diagnostics.length - 1] || null);
      }
      /* The press produced nothing usable, so it must not cost an allowance.
       * Signing in or running out never reserved one in the first place. */
      if (S.jobKey && err.kind !== 'sign-in' && err.kind !== 'over-limit') {
        try {
          var back = await api('/identity/mockup/abandon', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ jobKey: S.jobKey })
          });
          if (back && back.quota) {
            S.allowance = Object.assign({ signedIn: true }, back.quota);
            showAllowance();
          }
        } catch (e2) { /* the slot stays taken; the server is still the record */ }
      }
      showFail(msg);
    } finally {
      if (myToken === S.jobToken) {
        $('[data-upm-generate]').disabled = false;
        S.busy = false;
        setPhase(S.phase);
      }
    }
  }

  /* --------------------------------------------------------- base + render */

  function levelFrom(img, maskImg, targetW, mode, garmentImg) {
    var sc = targetW ? Math.min(1, targetW / img.width) : 1;
    var w = Math.round(img.width * sc), h = Math.round(img.height * sc);
    var scene = UPMRender.cv(w, h);
    var g = scene.getContext('2d');
    g.imageSmoothingQuality = 'high';
    g.drawImage(img, 0, 0, w, h);
    var id = g.getImageData(0, 0, w, h);
    var maskId = null;
    if (maskImg) {
      var mc = UPMRender.cv(w, h);
      mc.getContext('2d').drawImage(maskImg, 0, 0, w, h);
      maskId = mc.getContext('2d').getImageData(0, 0, w, h);
    }
    var garmentId = null;
    if (garmentImg) {
      /* The layer comes back at the model's own working size; it is sampled to
       * this level inside analyse, so it is read at its native resolution here
       * rather than being resampled twice. */
      var gc = UPMRender.cv(garmentImg.naturalWidth || garmentImg.width,
                            garmentImg.naturalHeight || garmentImg.height);
      gc.getContext('2d').drawImage(garmentImg, 0, 0);
      garmentId = gc.getContext('2d').getImageData(0, 0, gc.width, gc.height);
    }
    var surface = UPMCore.analyse(id, maskId, mode, garmentId);
    if (!surface) return null;
    return { scene: scene, surface: surface, cache: UPMRender.prepare(scene, surface), data: id };
  }

  /* Returns null when the base is usable, or why it is not - as a sentence for
   * the customer AND the numbers behind it, so a rejection can be checked later
   * instead of taken on trust. */
  async function adoptBase(got, opts) {
    opts = opts || {};
    var img = got.sceneImg, maskImg = got.maskImg, garmentImg = got.garmentImg || null;
    var mode = S.choices.presentation;
    var full = levelFrom(img, maskImg, 0, mode, garmentImg);
    if (!full) {
      return { reason: 'no-surface', measured: null,
               message: 'We could not find a clear printing area on that garment.' };
    }
    mark('analyse');
    /* The blank check guards an UNPREDICTABLE fresh generation: the model is
     * perfectly capable of printing something uninvited, and a customer should
     * not pay for that. A catalogue template is the opposite case - a fixed
     * picture the owner has already looked at and approved - so running an
     * automatic rejector over it turns a false positive into a template that
     * simply will not open. Two of the pilot's twenty-four are exactly that: a
     * V-neck opening and a pair of drawstrings read as a chest graphic, and
     * both garments are plainly blank.
     *
     * So trusted sources skip it. Custom generation does not, and its behaviour
     * is unchanged. */
    var blank = opts.trusted ? { ok: true, trusted: true }
                             : UPMCore.blankness(full.surface, full.data);
    mark('validate');
    if (!blank.ok) {
      return { reason: 'not-blank', measured: blank,
               message: 'That garment came back with a graphic already on it.' };
    }

    /* Layer evidence, checked BEFORE anybody is invited to place anything.
     *
     * A scene whose layers we cannot vouch for is refused here rather than
     * after the customer has spent a minute positioning their design on it.
     * A catalogue template is exempt: its layers were prepared and looked at
     * once, which is the whole point of a template. */
    var evidence = opts.trusted ? { ok: true, source: 'template' }
                                : UPMCore.layerEvidence(full.surface);
    /* An inferred surface is acceptable again now that the scene arrives clean -
     * but it is not taken on trust. The evidence gate above still measures it
     * against the matte and the quad, and still refuses a scene whose garment
     * swallowed the person, which is what it caught on the old brown hoodie. */
    if (!evidence.ok) {
      return { reason: 'no-layer-evidence', measured: evidence,
               /* "None of your allowance was used" rather than "nothing was
                * charged": the provider bills us for the attempt either way, and
                * saying otherwise would be untrue. What the customer keeps is
                * their slot. */
               message: 'We could not read that garment clearly enough to place a ' +
                        'design on it. None of your allowance was used. ' +
                        'Please try again.' };
    }
    S.evidence = evidence;
    /* The garment passed. Everything from here is local work on this machine -
     * the working copy, the clip, the foreground layer, the first render - and
     * it takes long enough on a phone to be worth naming. Yield once so the
     * stage is painted before the main thread is busy for a second. */
    setStage('prepare');
    await new Promise(function (r) { setTimeout(r, 30); });
    S.full = full;
    S.prev = levelFrom(img, maskImg, 760, mode, garmentImg) || full;
    resetPlacement();
    mark('prepare');
    /* A fresh scene opens fitted in the frame. Later edits leave the view
     * alone - nobody wants their zoom thrown away because they nudged the
     * design. */
    setZoom(fitZoom(), false, false);
    return null;
  }

  function resetPlacement() {
    if (!S.full) return;
    S.defaultPlacement = UPMCore.defaultPlacement(S.full.surface, S.artRatio);
    var lkEl = $('[data-upm-lock]');
    S.placement = Object.assign({}, S.defaultPlacement,
                                { locked: lkEl ? lkEl.checked : true });
    S.phase = 'ready';
    rerenderAll();
    setPhase('ready');
  }

  function rerender(level, quality) {
    if (!level || !S.art || !S.placement) return;
    UPMRender.render($('[data-upm-stage]'), level.scene, S.art, level.surface, level.cache,
      S.placement, { mesh: quality === 'fast' ? UPMCore.C.MESH_PREVIEW : UPMCore.C.MESH_FINAL });
    positionSelection();
  }
  function rerenderFast() { rerender(S.prev, 'fast'); }
  function rerenderAll() { rerender(S.full, 'final'); }



  /* -------------------------------------------------- selection + handles */

  /* The placed artwork in CSS pixels over the canvas, trimmed to the design's
   * own edges so the box and handles sit on the art, not on empty file. */
  function selectionRect() {
    if (!S.full || !S.placement) return null;
    var surf = S.full.surface, stage = $('[data-upm-stage]');
    var wrapEl = $('[data-upm-canvaswrap]');
    var r = stage.getBoundingClientRect(), wrap = wrapEl.getBoundingClientRect();
    if (!r.width) return null;
    /* The box is positioned inside the scroll container, so it has to be placed
     * in the scrolled content's coordinates, not the frame's. */
    var sl = wrapEl.scrollLeft, st = wrapEl.scrollTop;
    var sx = r.width / surf.w, sy = r.height / surf.h;
    var a = UPMCore.artQuadUV(surf, S.placement);
    var p0 = UPMCore.quadPoint(surf.quad, a.u0, a.v0);
    var p1 = UPMCore.quadPoint(surf.quad, a.u1, a.v1);
    var x = p0[0], y = p0[1], w = p1[0] - p0[0], h = p1[1] - p0[1];
    var t = (S.trim && !S.trim.empty) ? S.trim : { x: 0, y: 0, w: 1, h: 1 };
    x += t.x * w; y += t.y * h; w *= t.w; h *= t.h;
    return { left: (r.left - wrap.left) + sl + x * sx,
             top: (r.top - wrap.top) + st + y * sy,
             width: w * sx, height: h * sy };
  }

  function positionSelection() {
    var box = $('[data-upm-selbox]');
    var rect = selectionRect();
    if (!box || !rect) return;
    box.style.left = rect.left + 'px';
    box.style.top = rect.top + 'px';
    box.style.width = Math.max(10, rect.width) + 'px';
    box.style.height = Math.max(10, rect.height) + 'px';
    box.classList.toggle('is-locked', !!(S.placement && S.placement.locked));
  }

  function quadScale() {
    var q = S.full.surface.quad, surf = S.full.surface;
    return { w: Math.abs(q.tr[0] - q.tl[0]) / surf.w, h: Math.abs(q.bl[1] - q.tl[1]) / surf.h };
  }

  /* An advisory, never a restriction.
   *
   * Placement stays completely free - drag and resize anywhere, nothing is
   * clamped, nothing is disabled. But artwork pushed off the cloth is clipped
   * against the garment's real outline, and at a hem that means trousers, legs
   * and the shadow between them: it comes out looking torn rather than printed.
   * Saying so once is kinder than letting somebody download it and wonder what
   * went wrong. */
  function placementAdvice() {
    if (!S.full || !S.placement) return '';
    var off = UPMCore.offGarment(S.full.surface, S.placement);
    if (off < 0.06) return '';
    return off > 0.25
      ? 'A lot of your design is off the garment, so its edge will look torn. ' +
        'Drag it up or make it smaller to keep it on the fabric.'
      : 'Part of your design hangs off the garment and that edge will look ' +
        'ragged. Nudge it up a little if you would rather it sat on the fabric.';
  }

  function setPlacement(patch, fast) {
    if (!S.placement) return;
    Object.assign(S.placement, patch);
    invalidate();
    if (fast) rerenderFast(); else rerenderAll();
    setPhase(S.phase);
    if (!fast) {
      var advice = placementAdvice();
      if (advice) say(advice, 'warn'); else if (S.lastAdvice) say('');
      S.lastAdvice = advice;
    }
  }

  function resizeBy(handle, dxFrac, dyFrac, start) {
    var signX = /e$/.test(handle) ? 1 : (/w$/.test(handle) ? -1 : 0);
    var signY = /^s/.test(handle) ? 1 : (/^n/.test(handle) ? -1 : 0);
    var w = start.w, h = start.h, cx = start.cx, cy = start.cy;
    if (S.placement.locked) {
      /* Locked: one axis drives both, so proportions can never drift. */
      var dw = signX ? signX * dxFrac
                     : (signY * dyFrac) * (start.w / Math.max(0.0001, start.h));
      w = Math.max(0.05, start.w + dw);
      h = UPMCore.fitHeight(S.full.surface, w, S.artRatio);
      if (signX) cx = start.cx + signX * (w - start.w) / 2;
      if (signY) cy = start.cy + signY * (h - start.h) / 2;
    } else {
      if (signX) { w = Math.max(0.05, start.w + signX * dxFrac); cx = start.cx + signX * (w - start.w) / 2; }
      if (signY) { h = Math.max(0.05, start.h + signY * dyFrac); cy = start.cy + signY * (h - start.h) / 2; }
    }
    return { w: w, h: h, cx: cx, cy: cy };
  }

  function bindEditor() {
    var wrap = $('[data-upm-canvaswrap]'), stage = $('[data-upm-stage]');
    if (!wrap) return;
    var mode = null, handle = null, last = null, start = null;

    var pt = function (ev) {
      var t = ev.touches && ev.touches[0] ? ev.touches[0] : ev;
      var r = stage.getBoundingClientRect();
      return { x: (t.clientX - r.left) / r.width, y: (t.clientY - r.top) / r.height };
    };
    /* Raw client coordinates, for panning - which works in screen pixels and
     * must not be divided by the stage's size. */
    var raw = function (ev) {
      var t = ev.touches && ev.touches[0] ? ev.touches[0] : ev;
      return { x: t.clientX, y: t.clientY };
    };
    var down = function (ev) {
      if (!S.placement || !S.full || S.busy) return;
      /* Pan view drags the picture. It is a different job from moving the
       * design, so it is a different mode and the two never share a drag. */
      if (S.tool === 'pan') {
        mode = 'pan';
        last = raw(ev);
        start = { left: wrap.scrollLeft, top: wrap.scrollTop };
        if (ev.cancelable) ev.preventDefault();
        return;
      }
      if (S.phase === 'finished') S.phase = 'adjusted';
      var h = ev.target && ev.target.getAttribute && ev.target.getAttribute('data-h');
      mode = h ? 'resize' : 'move';
      handle = h || null;
      last = pt(ev);
      start = { cx: S.placement.cx, cy: S.placement.cy, w: S.placement.w, h: S.placement.h };
      setPhase(S.phase);
      if (ev.cancelable) ev.preventDefault();
    };
    var move = function (ev) {
      if (!mode) return;
      if (mode === 'pan') {
        var r = raw(ev);
        wrap.scrollLeft = start.left - (r.x - last.x);
        wrap.scrollTop = start.top - (r.y - last.y);
        if (ev.cancelable) ev.preventDefault();
        return;
      }
      var p = pt(ev), q = quadScale();
      var dx = (p.x - last.x) / (q.w || 1), dy = (p.y - last.y) / (q.h || 1);
      if (mode === 'move') setPlacement({ cx: start.cx + dx, cy: start.cy + dy }, true);
      else setPlacement(resizeBy(handle, dx, dy, start), true);
      if (ev.cancelable) ev.preventDefault();
    };
    var up = function () {
      if (!mode) return;
      var was = mode;
      mode = null; handle = null;
      if (was === 'pan') return;          /* nothing changed, nothing to redraw */
      rerenderAll(); setPhase(S.phase);
    };

    wrap.addEventListener('mousedown', down);
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
    wrap.addEventListener('touchstart', down, { passive: false });
    window.addEventListener('touchmove', move, { passive: false });
    window.addEventListener('touchend', up);

    /* Arrows nudge, Shift+arrows resize. Precision, and the only way in
     * without a pointer. */
    wrap.setAttribute('tabindex', '0');
    wrap.addEventListener('keydown', function (ev) {
      if (!S.placement || S.busy) return;
      var k = ev.key, step = ev.altKey ? 0.005 : 0.02;
      var dx = k === 'ArrowLeft' ? -step : k === 'ArrowRight' ? step : 0;
      var dy = k === 'ArrowUp' ? -step : k === 'ArrowDown' ? step : 0;
      if (!dx && !dy) return;
      ev.preventDefault();
      if (ev.shiftKey) {
        if (S.placement.locked) {
          var w = Math.max(0.05, S.placement.w + (dx || dy));
          setPlacement({ w: w, h: UPMCore.fitHeight(S.full.surface, w, S.artRatio) }, false);
        } else {
          setPlacement(dx ? { w: Math.max(0.05, S.placement.w + dx) }
                          : { h: Math.max(0.05, S.placement.h + dy) }, false);
        }
      } else {
        setPlacement({ cx: S.placement.cx + dx, cy: S.placement.cy + dy }, false);
      }
    });

    wrap.addEventListener('scroll', positionSelection, { passive: true });
    window.addEventListener('resize', reflow);
    if (window.matchMedia) {
      try { window.matchMedia('(orientation: portrait)').addEventListener('change', reflow); }
      catch (e) { /* older Safari; the resize event covers it */ }
    }
  }

  /* ------------------------------------------------------------- finish */

  async function placeImage() {
    if (S.busy || !S.full) return;
    S.busy = true;
    setPhase('placing');
    say('');
    await new Promise(function (r) { setTimeout(r, 30); });
    try {
      rerenderAll();
      $('[data-upm-selbox]').classList.remove('is-on');
      var blob = await new Promise(function (res) { $('[data-upm-stage]').toBlob(res, 'image/png'); });
      if (!blob) throw new Error('That did not finish. Press Place image again.');
      S.finishedBlob = blob;
      S.busy = false;
      setPhase('finished');
    } catch (e) {
      S.busy = false;
      say(e.message, 'warn');
      setPhase('adjusted');
    }
  }

  function download() {
    /* A rendered scene is finished the moment it arrives - there is no Place
     * step - so the file comes straight off the canvas. This is the DEMO image.
     * The customer's approved artwork is untouched in S.art and is what any
     * print would be made from; nothing here reads it or replaces it. */
    if (!S.finishedBlob && S.mode === 'rendered') {
      var st = $('[data-upm-stage]');
      if (!st) return;
      st.toBlob(function (b) { if (b) { S.finishedBlob = b; download(); } }, 'image/png');
      return;
    }
    if (!S.finishedBlob) return;
    var a = document.createElement('a');
    a.href = URL.createObjectURL(S.finishedBlob);
    a.download = 'upress-mockup-' + (S.artName.replace(/\.[^.]+$/, '') || 'design') + '.png';
    document.body.appendChild(a); a.click();
    setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 4000);
  }

  /* ------------------------------------------------------------- the view */

  /* Everything below changes what is on screen. None of it touches S.placement,
   * asks the server for anything, or reaches the exported file: the export is
   * taken from the canvas's own pixels, which these CSS sizes do not alter. */

  function applyZoom(keepCentre) {
    var wrap = $('[data-upm-canvaswrap]'), stage = $('[data-upm-stage]'), n = natural();
    if (!wrap || !stage) return;
    var pct = $('[data-upm-zoompct]'), range = $('[data-upm-zoomrange]');
    if (!n) {
      stage.style.width = ''; stage.style.height = '';
      if (pct) pct.textContent = '100%';
      return;
    }
    /* Hold the point in the middle of the frame still while the scale changes,
     * so zooming in does not throw the design off screen. */
    var before = keepCentre === false ? null : {
      x: (wrap.scrollLeft + wrap.clientWidth / 2) / Math.max(1, stage.offsetWidth),
      y: (wrap.scrollTop + wrap.clientHeight / 2) / Math.max(1, stage.offsetHeight)
    };
    stage.style.width = Math.max(40, Math.round(n.w * S.zoom)) + 'px';
    stage.style.height = Math.round(n.h * S.zoom) + 'px';
    if (before) {
      wrap.scrollLeft = before.x * stage.offsetWidth - wrap.clientWidth / 2;
      wrap.scrollTop = before.y * stage.offsetHeight - wrap.clientHeight / 2;
    }
    var shown = Math.round(S.zoom * 100);
    if (pct) pct.textContent = shown + '%';
    if (range && document.activeElement !== range) range.value = String(shown);
    requestAnimationFrame(positionSelection);
  }

  function setZoom(z, keepCentre, chosen) {
    S.zoom = Math.min(4, Math.max(0.1, z));
    if (chosen !== undefined) S.zoomChosen = chosen;
    applyZoom(keepCentre);
  }

  /* Turning a phone, or opening the laptop wider, changes the frame. If the
   * customer has picked a zoom, it is theirs and it stays; if they have not,
   * the picture re-fits rather than being left half off the edge. */
  function reflow() {
    if (!S.full) return;
    if (S.zoomChosen) applyZoom(false);
    else setZoom(fitZoom(), false, false);
  }

  function setTool(t) {
    S.tool = t;
    $$('[data-upm-tool]').forEach(function (b) {
      var on = b.getAttribute('data-upm-tool') === t;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $('[data-upm-canvaswrap]').classList.toggle('is-pan', t === 'pan');
    setPhase(S.phase);
  }

  /* The Build your look panel reflects S.choices. Anything that changes those
   * from outside the panel - a ready-made scene, a catalogue template - calls
   * this, so the controls never disagree with the picture on screen. */
  function syncChoiceUI() {
    applyDiagnostics();
    syncWidthBox();
    showSummary();
    applyDisplayMode();
    applyPrintSide();
    checkAgeConflict();
    ['garment', 'colour', 'presentation'].forEach(function (g) {
      $$('[data-upm-pick][data-upm-group="' + g + '"]').forEach(function (o) {
        var on = o.getAttribute('data-upm-value') === S.choices[g];
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && g === 'colour') $('[data-upm-colourname]').textContent = o.getAttribute('data-upm-name');
      });
    });
    applyDisplayMode();
  }

  /* -------------------------------------------------- ready-made scenes */

  /* A scene we already own, served from the theme. No provider call, no queue,
   * no validation retry - the garment is known to be blank because we checked
   * it when we made it. Everything after this point is the same code the
   * generated path uses, so placing, zooming and downloading behave
   * identically. */
  async function useLibrary(btn) {
    if (S.busy) return;
    if (!S.art) { say('Add your artwork first — step 01.', 'warn'); return; }
    var myToken = ++S.jobToken;
    S.busy = true;
    setPhase(S.phase);
    say('');
    showBusy(true);
    note('');
    markStart();
    $('[data-upm-busyhead]').textContent = 'Opening that scene…';
    setStage('check');

    $$('[data-upm-lib]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    /* Keep the rest of the panel honest about what is on screen. */
    S.choices.garment = btn.getAttribute('data-upm-lib-garment');
    S.choices.colour = btn.getAttribute('data-upm-lib-colour');
    S.choices.presentation = btn.getAttribute('data-upm-lib-mode');
    S.mode = 'composited';
    show('[data-upm-disclaim]', false);
    syncChoiceUI();

    try {
      var pair = await Promise.all([
        loadImage(btn.getAttribute('data-upm-lib-base')),
        loadImage(btn.getAttribute('data-upm-lib-mask')).catch(function () { return null; })
      ]);
      if (myToken !== S.jobToken) return;
      mark('transfer');
      var why = await adoptBase({ sceneImg: pair[0], maskImg: pair[1] }, { trusted: true });
      if (myToken !== S.jobToken) return;
      S.diagnostics.push({ at: new Date().toISOString(), attempt: 1,
        source: 'library:' + btn.getAttribute('data-upm-lib'),
        choices: Object.assign({}, S.choices), prompt: '', scene: '', matte: !!pair[1],
        verdict: why === null ? 'used' : why.reason, trusted: true,
        measured: why === null ? null : why.measured, timings: timings() });
      if (why !== null) throw new Error(why.message);
      showBusy(false);
      announce('Your mockup is ready. Drag the design to move it.');
      $('[data-upm-canvaswrap]').scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (e) {
      if (myToken !== S.jobToken) return;
      showFail(e.message || 'That scene would not open. Try another, or make one.');
    } finally {
      if (myToken === S.jobToken) {
        $('[data-upm-busyhead]').textContent = 'Creating your mockup…';
        S.busy = false;
        setPhase(S.phase);
      }
    }
  }

  /* ---------------------------------------------------------------- wire */

  function init() {
    var file = $('[data-upm-file]');
    if (file) file.addEventListener('change', function () { onFile(this.files[0]); });
    var drop = $('[data-upm-drop]');
    if (drop) {
      ['dragenter', 'dragover'].forEach(function (n) {
        drop.addEventListener(n, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
      });
      ['dragleave', 'drop'].forEach(function (n) {
        drop.addEventListener(n, function (e) { e.preventDefault(); drop.classList.remove('is-over'); });
      });
      drop.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files[0]) onFile(e.dataTransfer.files[0]);
      });
    }

    $$('[data-upm-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        var g = b.getAttribute('data-upm-group');
        $$('[data-upm-pick][data-upm-group="' + g + '"]').forEach(function (o) {
          o.setAttribute('aria-pressed', 'false');
        });
        b.setAttribute('aria-pressed', 'true');
        S.choices[g] = b.getAttribute('data-upm-value');
        if (g === 'colour') $('[data-upm-colourname]').textContent = b.getAttribute('data-upm-name');
        if (g === 'presentation') { applyDisplayMode(); checkAgeConflict(); }
        if (g === 'garment') applyPlacements();
        if (g === 'position') applyPlacements();
        showSummary();
      });
    });

    $$('[data-upm-choice]').forEach(function (el) {
      var h = function () {
        var key = el.getAttribute('data-upm-choice');
        S.choices[key] = el.value;
        if (key === 'printSide') applyPrintSide();
        if (key === 'position' || key === 'size' || key === 'garment' ||
            key === 'age') setTypicalWidth();
        if (key === 'age' || key === 'note') checkAgeConflict();
        showSummary();
        if (el.hasAttribute('data-upm-note')) {
          $('[data-upm-notecount]').textContent = String(el.value.length);
        }
      };
      el.addEventListener('input', h);
      el.addEventListener('change', h);
    });

    $$('[data-upm-lib]').forEach(function (b) {
      b.addEventListener('click', function () { useLibrary(b); });
    });
    /* Create my scene now renders the whole picture WITH the artwork on it.
     * The composite path is still what a ready-made template uses. */
    $('[data-upm-generate]').addEventListener('click', function () { renderScene(false); });
    var rg = $('[data-upm-regen]');
    if (rg) rg.addEventListener('click', function () { showAdjust(false); renderScene(false); });
    var ao = $('[data-upm-adjustopen]');
    if (ao) ao.addEventListener('click', function () {
      var panel = $('[data-upm-adjust]');
      showAdjust(!panel || panel.hidden);
    });
    var ac = $('[data-upm-adjustclose]');
    if (ac) ac.addEventListener('click', function () { showAdjust(false); });
    $$('[data-upm-adj]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        adjustScene(b.getAttribute('data-upm-adj'));
      });
    });

    /* The same guarded path as the button, so retrying cannot start a second
     * job while the first is still running either. */
    $('[data-upm-retry]').addEventListener('click', function () {
      if (S.busy) return;
      $('[data-upm-fail]').hidden = true;
      setPhase(S.phase);
      generate();
    });
    $('[data-upm-place]').addEventListener('click', placeImage);
    $('[data-upm-download]').addEventListener('click', download);
    var rsb = $('[data-upm-reset]');
    if (rsb) rsb.addEventListener('click', function () { if (S.full) resetPlacement(); });

    /* Export for support.
     *
     * A scene lives only in this tab. It is never stored on our side - that is
     * the privacy setting Dennis approved - so when a customer sees something
     * wrong, reloading to get a newer script is also what destroys the evidence.
     * This hands them the scene as a file instead, so a defect can be looked at
     * on the exact picture that produced it.
     *
     * Deliberately NOT a gallery: nothing is uploaded, nothing is written to an
     * account, nothing survives in the browser. One file, to their own device,
     * only when they ask for it.
     *
     * One file rather than three, because a phone handles a single download and
     * makes a mess of several. The base is on the left, its subject matte on the
     * right at the same size, and the placement and choices are written along
     * the bottom in plain text - readable by eye, no decoding needed. The matte
     * is drawn as white on black rather than put in the alpha channel: canvas
     * stores alpha premultiplied, so a transparent pixel would take its colour
     * with it. */
    $('[data-upm-export]').addEventListener('click', function () {
      if (!S.full) return;
      var src = S.full.scene, W = src.width, H = src.height, STRIP = 150;
      var out = UPMRender.cv(W * 2, H + STRIP), g = out.getContext('2d');
      g.fillStyle = '#000'; g.fillRect(0, 0, W * 2, H + STRIP);
      g.drawImage(src, 0, 0);
      var sub = S.full.surface.subject;
      var mi = g.createImageData(W, H), md = mi.data, i, k;
      for (k = 0, i = 0; k < W * H; k++, i += 4) {
        md[i] = md[i + 1] = md[i + 2] = sub[k] ? 255 : 0; md[i + 3] = 255;
      }
      g.putImageData(mi, W, 0);
      var meta = {
        v: 1, at: new Date().toISOString(), scene: [W, H],
        placement: S.placement && {
          cx: +S.placement.cx.toFixed(4), cy: +S.placement.cy.toFixed(4),
          w: +S.placement.w.toFixed(4), h: +S.placement.h.toFixed(4),
          locked: !!S.placement.locked
        },
        choices: S.choices, art: S.art ? [S.art.width, S.art.height] : null,
        zoom: +(S.zoom || 1).toFixed(3)
      };
      var text = JSON.stringify(meta);
      g.fillStyle = '#FFF';
      g.font = '22px ui-monospace, Menlo, Consolas, monospace';
      var line = '', yy = H + 32, ch = Math.floor((W * 2 - 40) / 13);
      for (i = 0; i < text.length; i += ch) {
        line = text.slice(i, i + ch);
        g.fillText(line, 20, yy); yy += 28;
        if (yy > H + STRIP - 6) break;
      }
      var c = S.choices || {};
      var name = ['upm-support', c.garment || 'garment', c.colour || 'colour',
                  c.presentation || 'model'].join('-') + '.png';
      out.toBlob(function (b) {
        if (!b) { announce('That scene could not be exported.'); return; }
        var u = URL.createObjectURL(b), a = document.createElement('a');
        a.href = u; a.download = name; document.body.appendChild(a); a.click();
        setTimeout(function () { URL.revokeObjectURL(u); a.remove(); }, 4000);
        announce('Scene exported to your device. Nothing was uploaded.');
      }, 'image/png');
    });
    var lk = $('[data-upm-lock]');
    if (lk) lk.addEventListener('change', function () {
      if (!S.placement) return;
      S.placement.locked = this.checked;
      if (this.checked) {
        setPlacement({ h: UPMCore.fitHeight(S.full.surface, S.placement.w, S.artRatio) }, false);
      }
      positionSelection();
    });
    $('[data-upm-zoomrange]').addEventListener('input', function () {
      setZoom(Number(this.value) / 100, undefined, true);
    });
    /* Fit to view is the largest scale that still shows the whole mockup, so it
     * depends on the frame; Reset zoom is exactly 1:1. They are different
     * numbers on every screen - on a laptop the fit is around a fifth. */
    $('[data-upm-fit]').addEventListener('click', function () {
      setZoom(fitZoom(), false, false);
      var w = $('[data-upm-canvaswrap]');
      w.scrollLeft = (w.scrollWidth - w.clientWidth) / 2;
      w.scrollTop = (w.scrollHeight - w.clientHeight) / 2;
      requestAnimationFrame(positionSelection);
    });
    $('[data-upm-zoomreset]').addEventListener('click', function () { setZoom(1, undefined, true); });
    $$('[data-upm-tool]').forEach(function (b) {
      b.addEventListener('click', function () { setTool(b.getAttribute('data-upm-tool')); });
    });

    /* This whole page is a working tool. The Postscript widget declares
     * z-index 2147483647 - the 32-bit maximum - so it cannot be out-stacked and
     * would sit over the editor; it is taken out of the flow for as long as the
     * customer is on the Lab, and restored everywhere else. */
    document.documentElement.classList.add('upm-working');
    bindEditor();
    loadAllowance();
    /* The placement buttons and the person fields are both drawn by JS from
     * the chosen garment, and neither ran at boot - applyPlacements was only
     * reached by clicking a garment tile. So a customer landing on the page
     * saw "Where should the design go?" with nothing underneath it until they
     * happened to click a garment. Every earlier check missed it because the
     * check clicked a tile first. */
    applyPlacements();
    applyDisplayMode();
    showSummary();
    setPhase('empty');
    wireGallery();


  /* Leaving with a job in flight.
   *
   * A slot is taken when Create my scene is pressed and given back when
   * something fails. Closing the tab is neither, so the slot used to stay taken
   * for a scene the customer never saw. This is the cheap half of the fix: a
   * beacon survives the page being torn down, where a normal fetch does not.
   *
   * It is best-effort on purpose - a lost connection sends nothing at all - so
   * the server also sweeps jobs that were abandoned without a word. Nothing is
   * stored to make this work; the job row already exists and this only settles
   * it sooner than the sweep would. */
  function releaseOnLeave() {
    if (!S.jobKey || !S.busy) return;
    var body = JSON.stringify({ jobKey: S.jobKey, reason: 'left' });
    var url = (cfg.proxy || '/apps/upress-ai') + '/identity/mockup/abandon';
    var sent = false;
    try {
      if (navigator.sendBeacon) {
        sent = navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }));
      }
    } catch (e) { sent = false; }
    if (!sent) {
      try {
        fetch(url, { method: 'POST', body: body, keepalive: true,
                     headers: { 'Content-Type': 'text/plain' } });
      } catch (e2) { /* the server sweep is the backstop */ }
    }
    S.jobKey = null;
  }

  /* pagehide covers a close, a reload and a back-navigation, and unlike
   * beforeunload it is not skipped on mobile Safari. The hidden check catches
   * a phone being locked or the app being switched away from. */
  window.addEventListener('pagehide', releaseOnLeave);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') releaseOnLeave();
  });

    window.UPM_DEBUG = S;
    /* Readable from the console after a failure: what was asked for, the prompt
     * the server built, the scene that came back and what the checker measured.
     * The customer's artwork is not in it. */
    Object.defineProperty(window, 'UPM_DIAG', { get: function () { return S.diagnostics; } });
  }


  /* ---------------------------------------------------- browse templates
   *
   * The owner's library of blank garment bases. Choosing one costs nothing:
   * no provider call, no monthly allowance, no waiting. It is the same editor
   * afterwards - only where the base came from differs.
   *
   * Nothing about the taxonomy is written into this file. The facets are built
   * from whatever the catalogue returns, so a new collection or colour appears
   * the moment the row exists.
   */
  var G = {
    loaded: false, loading: null, all: [], shown: 0, sel: null,
    q: '', filters: {}, PAGE: 24
  };

  /* Which fields become filters, in the order they are offered. A field the
   * catalogue stops sending simply disappears; one it starts sending appears. */
  var FACETS = [
    { key: 'audience', label: 'Audience', value: function (t) { return t.audienceLabel; },
      id: function (t) { return t.audience; } },
    { key: 'presentation', label: 'Presentation',
      value: function (t) { return t.presentationLabel || MODE_LABEL[t.mode]; },
      id: function (t) { return t.presentation || t.mode; } },
    { key: 'collection', label: 'Theme', value: function (t) { return t.collectionLabel; },
      id: function (t) { return t.collection; } },
    { key: 'garment', label: 'Garment', value: function (t) { return t.garmentLabel; },
      id: function (t) { return t.garment; } },
    { key: 'color', label: 'Colour', value: function (t) { return t.colorLabel; },
      id: function (t) { return t.color; } },
  ];
  var MODE_LABEL = { model: 'On a model', flat: 'Flat lay', hanging: 'Hanging garment' };
  /* Only for the little dot on a colour badge; the catalogue supplies the name. */
  var SWATCH = {
    black: '#101010', white: '#FFFFFF', heather: '#BFC2C7', charcoal: '#4A4D52',
    navy: '#1F2A44', royal: '#1B4FD8', lightblue: '#8FC4E8', olive: '#5A5F3C',
    brown: '#76513B', tan: '#D8C3A0', red: '#B3262B', orange: '#FF6A00',
    yellow: '#F5CB1B', pink: '#FF7FB0', purple: '#6B3FA0', burgundy: '#6E1F2E',
    forest: '#27503A', cream: '#F2E8D5'
  };

  function galEls() {
    return {
      dlg: $('[data-upm-gal]'), grid: $('[data-upm-gal-grid]'),
      count: $('[data-upm-gal-count]'), facets: $('[data-upm-gal-facets]'),
      empty: $('[data-upm-gal-empty]'), error: $('[data-upm-gal-error]'),
      more: $('[data-upm-gal-more]'), sel: $('[data-upm-gal-sel]'),
      use: $('[data-upm-gal-use]'), q: $('[data-upm-gal-q]'),
      clear: $('[data-upm-gal-clear]')
    };
  }

  function assetUrl(rel) { return (cfg.proxy || '/apps/upress-ai') + rel; }

  async function loadCatalog() {
    if (G.loaded) return G.all;
    if (G.loading) return G.loading;
    /* The TEST page asks for owner-approved rows as well as published ones,
     * so a pilot can be reviewed in the real gallery before it goes public.
     * The live page leaves this off. */
    var q = cfg.templatePreview ? '/templates/catalog?include=approved' : '/templates/catalog';
    G.loading = api(q).then(function (r) {
      G.all = (r && r.ok && Array.isArray(r.templates)) ? r.templates : [];
      G.loaded = !!(r && r.ok);
      G.loading = null;
      return G.all;
    }).catch(function () { G.loading = null; G.loaded = false; return []; });
    return G.loading;
  }

  function matches(t) {
    for (var i = 0; i < FACETS.length; i++) {
      var f = FACETS[i], picked = G.filters[f.key];
      if (!picked || !picked.length) continue;
      var id = f.id ? f.id(t) : f.value(t);
      if (picked.indexOf(String(id)) === -1) return false;
    }
    if (G.q) {
      var hay = [t.title, t.collectionLabel, t.garmentLabel, t.colorLabel,
                 MODE_LABEL[t.mode], t.audience, t.occlusion].join(' ').toLowerCase();
      var words = G.q.toLowerCase().split(/\s+/).filter(Boolean);
      for (var w = 0; w < words.length; w++) if (hay.indexOf(words[w]) === -1) return false;
    }
    return true;
  }

  function buildFacets() {
    var e = galEls();
    e.facets.textContent = '';
    FACETS.forEach(function (f) {
      var seen = [], byId = {};
      G.all.forEach(function (t) {
        var id = String(f.id ? f.id(t) : f.value(t) || '');
        if (!id) return;                      /* flat lay and hanging have no gender */
        if (!byId[id]) { byId[id] = f.value(t) || id; seen.push(id); }
      });
      if (seen.length < 2) return;            /* a filter with one choice filters nothing */
      var row = document.createElement('div');
      row.className = 'upmg__facet';
      var lab = document.createElement('b'); lab.textContent = f.label; row.appendChild(lab);
      seen.forEach(function (id) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'upmg__tag'; b.textContent = byId[id];
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          var cur = G.filters[f.key] || (G.filters[f.key] = []);
          var at = cur.indexOf(id);
          if (at === -1) cur.push(id); else cur.splice(at, 1);
          b.setAttribute('aria-pressed', at === -1 ? 'true' : 'false');
          G.shown = 0; renderGrid();
        });
        row.appendChild(b);
      });
      e.facets.appendChild(row);
    });
  }

  function renderGrid() {
    var e = galEls(), list = G.all.filter(matches);
    var page = list.slice(0, G.shown + G.PAGE);
    G.shown = page.length;
    e.grid.textContent = '';
    page.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'upmg__card'; b.setAttribute('role', 'listitem');
      b.setAttribute('aria-pressed', G.sel && G.sel.id === t.id ? 'true' : 'false');
      var img = document.createElement('img');
      /* Thumbnails only, and lazily: a gallery must never pull down the
         full-size bases just to be looked at. */
      img.loading = 'lazy'; img.decoding = 'async';
      img.width = 168; img.height = 252; img.alt = '';
      img.src = assetUrl(t.thumb);
      var cap = document.createElement('div'); cap.className = 'upmg__cap';
      var nm = document.createElement('b'); nm.textContent = t.collectionLabel;
      cap.appendChild(nm);
      /* Badges rather than one run-on line: what a template IS should be
         readable at a glance while scanning a grid. */
      var badges = document.createElement('div'); badges.className = 'upmg__badges';
      [t.garmentLabel, t.presentationLabel || MODE_LABEL[t.mode], t.audienceLabel]
        .filter(Boolean).forEach(function (txt) {
          var e = document.createElement('span');
          e.className = 'upmg__badge'; e.textContent = txt; badges.appendChild(e);
        });
      if (t.colorLabel) {
        var cb = document.createElement('span');
        cb.className = 'upmg__badge upmg__badge--colour';
        var dot = document.createElement('i');
        dot.className = 'upmg__dot';
        dot.style.background = SWATCH[t.color] || '#888';
        cb.appendChild(dot);
        cb.appendChild(document.createTextNode(t.colorLabel));
        badges.appendChild(cb);
      }
      cap.appendChild(badges);
      var tick = document.createElement('span');
      tick.className = 'upmg__tick'; tick.setAttribute('aria-hidden', 'true');
      tick.textContent = '✓';
      b.appendChild(img); b.appendChild(tick); b.appendChild(cap);
      b.addEventListener('click', function () { selectTemplate(t); });
      e.grid.appendChild(b);
    });
    var total = G.all.length;
    e.count.textContent = list.length === total
      ? (total + (total === 1 ? ' template' : ' templates'))
      : (list.length + ' of ' + total + ' templates');
    show('[data-upm-gal-empty]', !list.length && G.loaded);
    show('[data-upm-gal-error]', !G.loaded);
    show('[data-upm-gal-more]', list.length > page.length);
    var active = FACETS.reduce(function (n, f) {
      return n + (G.filters[f.key] || []).length;
    }, 0);
    show('[data-upm-gal-clear]', !!G.q || active > 0);
    var tgl = $('[data-upm-gal-toggle]');
    if (tgl) {
      tgl.textContent = 'Filters';
      if (active) {
        var cnt = document.createElement('b'); cnt.textContent = String(active);
        tgl.appendChild(cnt);
      }
    }
  }

  function selectTemplate(t) {
    G.sel = t;
    var e = galEls();
    e.sel.textContent = t.title;
    e.use.disabled = false;
    $$('.upmg__card').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
    renderGrid();
  }

  async function openGallery() {
    var e = galEls();
    if (!e.dlg) return;
    if (typeof e.dlg.showModal === 'function') e.dlg.showModal(); else e.dlg.setAttribute('open', '');
    e.count.textContent = 'Loading templates…';
    await loadCatalog();
    buildFacets();
    G.shown = 0;
    renderGrid();
    if (e.q) e.q.focus();
  }

  function closeGallery() {
    var e = galEls();
    if (!e.dlg) return;
    if (typeof e.dlg.close === 'function') e.dlg.close(); else e.dlg.removeAttribute('open');
  }

  /* Loading a template is local work on a picture we already own. It must not
   * reach the provider, must not take a slot, and must not quietly disagree
   * with what the Build your look panel is showing - so the panel is moved to
   * match the template. The customer's uploaded artwork is never touched. */
  async function useTemplate(t) {
    if (S.busy) return;
    if (!S.art) {
      /* Browsing with nothing uploaded is fine and deliberate; placing is not,
         because there would be nothing to place. Say so and keep the choice. */
      closeGallery();
      say('Add your artwork first — step 01.', 'warn');
      return;
    }
    var myToken = ++S.jobToken;
    closeGallery();
    S.busy = true;
    setPhase(S.phase);
    say('');
    showBusy(true);
    note('');
    markStart();
    $('[data-upm-busyhead]').textContent = 'Opening your template…';
    setStage('prepare');
    try {
      var pair = await Promise.all([
        loadImage(assetUrl(t.base)),
        loadImage(assetUrl(t.matte)).catch(function () { return null; })
      ]);
      if (myToken !== S.jobToken) return;
      /* Keep the Build your look panel honest about what is on screen. */
      S.choices.garment = t.garment;
      S.choices.colour = t.color;
      S.choices.presentation = t.mode;
      /* A template is composited here, so the editor's placement tools
       * come back; a rendered scene has the print baked in and they do not. */
      S.mode = 'composited';
      show('[data-upm-disclaim]', false);
      syncChoiceUI();
      $$('[data-upm-lib]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      var why = await adoptBase({ sceneImg: pair[0], maskImg: pair[1] }, { trusted: true });
      if (myToken !== S.jobToken) return;
      /* A new base means any file already exported belongs to the old one. */
      S.finishedBlob = null;
      S.diagnostics.push({ at: new Date().toISOString(), attempt: 1,
        source: 'template:' + t.id, choices: Object.assign({}, S.choices),
        prompt: '', scene: '', matte: !!pair[1],
        verdict: why === null ? 'used' : why.reason, trusted: true,
        paid: false, quota: 'not-consumed', timings: timings() });
      if (why !== null) throw new Error(why.message);
      showBusy(false);
      announce('Template ready. Drag your design to move it.');
      $('[data-upm-canvaswrap]').scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (err) {
      if (myToken !== S.jobToken) return;
      showFail(err.message || 'That template would not open. Try another, or create a scene.');
    } finally {
      if (myToken === S.jobToken) { S.busy = false; setPhase(S.phase); }
    }
  }

  function wireGallery() {
    var e = galEls();
    if (!e.dlg) return;
    $$('[data-upm-browse]').forEach(function (b) {
      b.addEventListener('click', function () { openGallery(); });
    });
    var x = $('[data-upm-gal-close]');
    if (x) x.addEventListener('click', closeGallery);
    if (e.more) e.more.addEventListener('click', function () { renderGrid(); });
    if (e.use) e.use.addEventListener('click', function () {
      if (G.sel) useTemplate(G.sel);
    });
    var tg = $('[data-upm-gal-toggle]');
    if (tg) tg.addEventListener('click', function () {
      var panel = $('[data-upm-gal-filters]');
      var open = tg.getAttribute('aria-expanded') === 'true';
      tg.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) panel.hidden = open;
    });
    if (e.clear) e.clear.addEventListener('click', function () {
      G.q = ''; G.filters = {}; if (e.q) e.q.value = '';
      $$('.upmg__tag').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      G.shown = 0; renderGrid();
    });
    if (e.q) {
      var t = null;
      e.q.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () { G.q = e.q.value.trim(); G.shown = 0; renderGrid(); }, 140);
      });
    }
    /* <dialog> closes itself on Escape; this keeps our own state in step. */
    e.dlg.addEventListener('close', function () { /* selection is kept on purpose */ });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
